import { useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import Table from 'src/components/atoms/table/table';
import { User } from 'src/models/user.model';
import { Icon } from '../../../atoms/icon';
import { EDIT_TIMESHEET_PERMISSION, isAuthorizedToHandleCapability } from '../../../../utils/capability-utils';
import { useAppSelector } from '../../../../reducers';

type Props = {
  user: User;
};

export const TimesheetsTableCardUser = (props: Props) => {
  const { user } = props;
  const { user: loggedUser } = useAppSelector(state => state.authentication);

  const navigate = useNavigate();

  return (
    <Table.Row>
      <Table.Cell>{user.anagraphic ? `${user.anagraphic.firstname} ${user.anagraphic.lastname}` : user.email}</Table.Cell>
      <Table.Cell>{user.authority?.name}</Table.Cell>
      <Table.Cell align="right">
        {loggedUser && isAuthorizedToHandleCapability(loggedUser, EDIT_TIMESHEET_PERMISSION) && (
          <Button onClick={() => navigate(`/timesheets/${user.id}`, { state: user })}>
            <Icon content="arrowRight" />
          </Button>
        )}
      </Table.Cell>
    </Table.Row>
  );
};
